module.exports = __webpack_public_path__ + "img/Racing Point RP19_lateral view_final.ef9165dc.png";